import { AudienceListsActionInitiatedResponse, SelectedMergeAudienceLists } from '@/types/registration.types';
import { Post } from '../helpers';

export default function MergeLists({
  channel,
  projectUuid,
  body,
  signal,
}: {
  channel: number;
  projectUuid: string;
  body: SelectedMergeAudienceLists;
  signal?: AbortSignal;
}) {
  return Post<AudienceListsActionInitiatedResponse>({
    url: `/v4/admin/attendees/${channel}/${projectUuid}/merge-lists`,
    body,
    signal,
  });
}
